.UpscopeWidget__Container {
  display: flex;
  border-left: 1px solid #006190;
  height: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
}

.UpscopeWidget__Alert {
  border: 1px solid #6d8993;
  border-radius: 2px;
  background-color: #fbfeff;
  margin-top: 10px;
  padding: 5px 5px 0;
  color: #006190;
}

.UpscopeWidget__Logo {
  height: 20px;
  width: 60px;
  background-image: url("data-url:../images/logo_full.svg");
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
}

.UpscopeWidget__Screenshare__Container {
  margin-top: 10px;
  padding: 5px 5px 0;
}

.UpscopeWidget__Alert p {
  margin: 0 0 5px;
}

.UpscopeWidget__Alert__Error {
  border-color: #926c6c;
  background-color: #fffbfb;
  color: #500000;
}

.UpscopeWidget__Button,
.UpscopeWidget__Input {
  display: block;
  width: 100%;
  height: 30px;
  background: white;
  border-radius: 3px;
  box-shadow: none;
  border: 1px solid rgb(216, 220, 222);
  font-size: 12px;
  outline: none;
  margin-top: 8px;
  transition:
    border-color 0.25s ease-in-out,
    box-shadow 0.1s ease-in-out,
    background-color 0.25s ease-in-out,
    color 0.25s ease-in-out;
}

.UpscopeWidget__Input {
  padding: 0;
  margin: 10px 0 0;
  text-align: center;
}

.UpscopeWidget__Input::placeholder {
  color: #dddddd;
}

.UpscopeWidget__Button {
  cursor: pointer;
  font-weight: 600;
}

.UpscopeWidget__Button:hover {
  background: rgb(233, 235, 237);
}

.UpscopeWidget__Input:focus {
  border-color: rgb(31, 115, 183);
}
